<template>
    <div>

        <rkm-row>

            <rkm-col cols="3">
                <rkm-form-date-picker
                    label="Data"
                    :max-date="data.form.dataAtual"
                    v-model="data.model.cadastro.dataUsuarioResponsavel"
                    :validations="validations.data"
                    :disabled="isAmbulatorio"
                    right
                />
            </rkm-col>

            <rkm-col cols="9">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :requestQueryStringParams="autocompleteRequestParams.usuario"
                    :searchFields="fields.autocomplete.usuario"
                    :validations="validations.usuario"
                    text-field="cidadaoNome"
                    label="Profissional"
                    placeholder="Digite o nome ou número do conselho profissional"
                    v-model="data.model.cadastro.usuario"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="unidades"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="data.model.cadastro.unidadeId"
                    :validations="validations.unidade"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="isDisabled"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="infraestruturas"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.cadastro.infraestruturaId"
                    :validations="validations.infraestrutura"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="data.model.cadastro.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Código da equipe"
                    :options="equipes"
                    textField="descricao"
                    v-model="data.model.cadastro.equipeId"
                    :validations="validations.equipe"
                    valueField="id"
                    show-default-option
                    :disabled="data.model.cadastro.infraestruturaId == null"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Ocupação"
                    :options="ocupacoes"
                    textField="codigoNome"
                    v-model="data.model.cadastro.ocupacaoId"
                    :validations="validations.ocupacao"
                    valueField="id"
                    show-default-option
                    :disabled="data.model.cadastro.infraestruturaId == null"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Filters
import format from '@/filters/formats'

// Mixins
import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Enums.
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'

export default {
    computed: {
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.PROCEDIMENTOS
                },
            }
        },
        validations() {
            return {
                usuario: { required: true },
                unidade: { required: true },
                infraestrutura: { required: true },
                equipe: { required: true },
                ocupacao: { required: true },
                data: { required: true },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        isDisabled() {

            return !this.data.model.cadastro.usuario
                || this.data.model.cadastro.usuario && !this.data.model.cadastro.usuario.id
        }
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            procedimento: this.getConectaSusRepository('atencaoBasica.procedimento'),
            atendimentoDomiciliar: this.getConectaSusRepository('atencaoBasica.atendimentoDomiciliar')
        }
    },
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getUnidades() {

            this.setLoading()

            this.repositories.procedimento.getUnidades({usuario_id: this.data.model.cadastro.usuario.id})
                .then(({ data }) => {

                    this.unidades = data

                    if (data.length === 1){

                        this.data.model.cadastro.unidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {

            this.setLoading()

            this.repositories.procedimento.getEquipes({
                usuario_id: this.data.model.cadastro.usuario.id,
                infraestrutura_id: this.data.model.cadastro.infraestruturaId
            })
                .then(({ data }) => {

                    this.equipes = data
                    this.data.form.equipes = data

                    if (data.length === 1){

                        this.data.model.cadastro.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {

            this.setLoading()

            if(this.data.model.atendimentoDomiciliarId) {
                this.repositories.atendimentoDomiciliar.getOcupacoes({
                    usuario_id: this.data.model.cadastro.usuario.id,
                    infraestrutura_id: this.data.model.cadastro.infraestruturaId
                })
                    .then(({ data }) => {
                        this.ocupacoes = data
                        this.data.form.ocupacoes = data
                        if (data.length === 1){
                            this.data.model.cadastro.ocupacaoId = data[0].id
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.procedimento.getOcupacoes({
                    usuario_id: this.data.model.cadastro.usuario.id,
                    infraestrutura_id: this.data.model.cadastro.infraestruturaId
                })
                    .then(({ data }) => {

                        this.ocupacoes = data
                        this.data.form.ocupacoes = data

                        if (data.length === 1){

                            this.data.model.cadastro.ocupacaoId = data[0].id
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getInfraestruturas() {

            this.setLoading()

            this.repositories.procedimento.getInfraestruturas({
                usuario_id: this.data.model.cadastro.usuario.id,
                unidade_id: this.data.model.cadastro.unidadeId
            })
                .then(({ data }) => {

                    this.infraestruturas = data

                    if (data.length === 1) {

                        this.data.model.cadastro.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setCadastro(field) {

            if (field === 'usuario'){

                this.data.model.cadastro.unidadeId = null
                this.data.model.cadastro.infraestruturaId = null
                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
            } else if (field === 'infraestrutura'){

                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
            } else {

                this.data.model.cadastro.infraestruturaId = null
                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
            }
        },
        handleAreaResponsavel() {

            const areaResponsavel = this.data.model.cadastro.usuario && this.data.model.cadastro.unidadeId
                && this.data.model.cadastro.infraestruturaId && this.data.model.cadastro.equipeId
                && this.data.model.cadastro.ocupacaoId && this.data.model.cadastro.dataUsuarioResponsavel

            if (areaResponsavel) {

                this.getAtendimentoResponsavel()
            }
        },
        getAtendimentoResponsavel() {

            this.setLoading()

            this.repositories.procedimento.getAtendimentoResponsavel({
                id: this.data.model.id,
                usuario_id: this.data.model.cadastro.usuario.id,
                infraestrutura_id: this.data.model.cadastro.infraestruturaId,
                equipe_id: this.data.model.cadastro.equipeId,
                ocupacao_id: this.data.model.cadastro.ocupacaoId,
                data_usuario_responsavel: this.getFormatedDate(this.data.model.cadastro.dataUsuarioResponsavel, 'YYYY-MM-DD')
            })
                .then(({ data }) => {

                    if (data.id) {

                        this.showConfirmation(
                            `Já existe uma ficha criada para o para o profissional, unidade, local de atendimento,
                            equipe, ocupação, e data específica. Para prosseguir com o cadastro, você será
                            direcionado a ficha de procedimentos correspondente a esses dados. Deseja continuar?`,
                            async () => this.$emit('redirect', data.id),
                            async () => this.$emit('exit')
                        )
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getProcedimentosUsuario() {

            this.setLoading()

            this.repositories.procedimento.getProcedimentosUsuario({ocupacao_id: this.data.model.cadastro.ocupacaoId})
                .then(({ data }) => {

                    this.data.form.procedimentoUsuario = Object.assign(data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    data() {
        return {
            unidades: [],
            infraestruturas: [],
            equipes: [],
            ocupacoes: [],
            enums: {
                permissao
            }
        }
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    props: {
        data: { type: Object, required: false },
        isAmbulatorio: { type: Boolean, default: false },
    },
    mounted () {
        this.$nextTick(function () {

            if (this.data.model.cadastro.usuario && this.data.model.cadastro.usuario.id)  {

                this.getUnidades()

                if (this.data.model.cadastro.unidadeId) {

                    this.getInfraestruturas()
                    this.getEquipes()
                    this.getOcupacoes()
                }
            }
        })
    },
    watch: {
        'data.form.equipes': function (equipes) {

            this.equipes = equipes
        },
        'data.model.cadastro.usuario': function (usuario) {

            if (usuario && !this.isAmbulatorio) {

                this.getUnidades()
                this.handleAreaResponsavel()
            }

            this.setCadastro('usuario')
        },
        'data.model.cadastro.unidadeId': function (unidadeId) {

            if (unidadeId && !this.isAmbulatorio) {

                this.getInfraestruturas()
                this.handleAreaResponsavel()
            }

            this.setCadastro('unidade')
        },
        'data.model.cadastro.infraestruturaId': function (infraestruturaId) {

            if (infraestruturaId && !this.isAmbulatorio) {

                this.getEquipes()
                this.getOcupacoes()
                this.handleAreaResponsavel()
            }

            this.setCadastro('infraestrutura')
        },
        'data.model.cadastro.equipeId': function (equipeId) {

            if (equipeId && !this.isAmbulatorio) {

                this.handleAreaResponsavel()
            }
        },
        'data.model.cadastro.ocupacaoId': function (ocupacaoId) {

            if (ocupacaoId && !this.isAmbulatorio) {

                this.getProcedimentosUsuario()
                this.handleAreaResponsavel()
            }
        },
        'data.model.cadastro.dataUsuarioResponsavel': function (data) {

            if (data && !this.isAmbulatorio) {

                this.handleAreaResponsavel()
            }
        },
    }
}
</script>